import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  VStack,
  HStack,
  Button,
  Divider,
} from "@chakra-ui/react";

const jobData = [
  {
    team: "Marketing Team",
    roles: [
      {
        title: "Social Media Coordinator",
        location: "Work from home",
        description:
          "Join us as we transform the digital world! We are on the hunt for a skilled Content Strategist to create engaging stories that connect with audiences. If you have a passion for storytelling and expertise in SEO, whether working remotely or in a hybrid environment, we want to hear from you!",
      },
      {
        title: "Content Strategist",
        location: "Work from home",
        description:
          "We're looking for a PPC Specialist to enhance our clients’ success through strategic advertising campaigns. If you're analytical and enjoy optimizing for performance, whether in-office or working from home, apply today!",
      },
      {
        title: "PPC Specialist",
        location: "In-office",
        description:
          "Seeking a creative Graphic Designer to bring our clients’ ideas to life. If you have a strong portfolio and a unique artistic vision, whether in a hybrid role or working from home, we want you on our team!",
      },
    ],
  },
  {
    team: "Creative Team",
    roles: [],
  },
  {
    team: "Doggle's Digital Marketing Team",
    roles: [],
  },
];

const CareerOpenings = () => {
  return (
    <Box py={{ base: 10, md: 16 }} px={{ base: 4, md: 0 }} bg="#F5F5F5">
      <Container maxW="container.lg">
        {/* Header Section */}
        <VStack align="start" spacing={4} mb={10}>
          <Text fontWeight="semibold" fontSize="sm" color="#000000" className="fade-in-up">
            Become a Part of Doggle!
          </Text>
          <Heading as="h2" fontSize={{ base: "2xl", md: "3xl" } } className="fade-in-up">
            Available Positions at Doggle
          </Heading>
          <Text fontSize="md" color="#000000" className="fade-in-up">
            At Doggle, we are searching for innovative thinkers to join our vibrant team.
            Discover thrilling opportunities in the ever-evolving field of digital marketing,
            whether you prefer in-office, remote, or hybrid work.
          </Text>
        </VStack>

        {/* Accordion Section */}
        <Accordion allowMultiple defaultIndex={[0]}>
          {jobData.map((team, idx) => (
            <AccordionItem key={idx} border="1px solid #ccc" borderRadius="md" mb={4}>
              {({ isExpanded }) => (
                <>
                  <AccordionButton
                    px={4}
                    py={4}
                    fontWeight="bold"
                    fontSize="lg"
                    
                    _expanded={{ bg: "gray.100" }}
                  >
                    <Box flex="1" textAlign="left"  className="fade-in-up">
                      {team.team}
                    </Box>
                    <AccordionIcon bg={'transparent !important'}  />
                  </AccordionButton>

                  <AccordionPanel pb={4}>
                    {team.roles.length > 0 ? (
                      team.roles.map((role, i) => (
                        <Box key={i} mb={6}>
                          <HStack
                            justify="space-between"
                            flexDir={{ base: "column", md: "row" }}
                            align={{ base: "flex-start", md: "center" }}
                          >
                            <VStack align="start" spacing={0}>
                              <Text fontWeight="semibold" fontSize="md" className="fade-in-up">
                                {role.title}
                              </Text>
                              <Text fontSize="sm" color="gray.500" className="fade-in-up">
                                {role.location}
                              </Text>
                            </VStack>
                            <Button variant="outline" size="sm" mt={{ base: 2, md: 0 }} border={'1px solid black'} className="fade-in-up">
                              Submit Your Application
                            </Button>
                          </HStack>
                          <Text mt={3} fontSize="sm" color="gray.700" className="fade-in-up">
                            {role.description}
                          </Text>
                          {i !== team.roles.length - 1 && <Divider my={5} />}
                        </Box>
                      ))
                    ) : (
                      <Text fontSize="sm" color="gray.600" className="fade-in-up">
                        Currently no openings in this team.
                      </Text>
                    )}
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          ))}
        </Accordion>
      </Container>
    </Box>
  );
};

export default CareerOpenings;
